export default {
  'reportGroups.title': 'Configurar Grupo de Reportes',
  'reportGroups.form.powerBIServerConfigurationId': 'Configuración Servidor Power BI',
  'reportGroups.form.powerBIReportGroupId': 'Id Grupo de PowerBI',
  'reportGroups.permissionsFiltersLogicalOperator': 'Operador Lógico Permisos',
};
